<template>
  <v-btn :elevation="elevation"
         :dark="dark"
         :color="color"
         :small="size === 'small'"
         :x-small="size === 'x-small'"
         :large="size === 'large'"
         :x-large="size === 'x-large'"
         fab
         @click="() => $emit('click')"
  >
    <v-icon>{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'Fab',
  props: {
    icon: { type: String, default: null, }
  },
  computed: {
    size() {
      return this.$store.state.theme.fabsSize;
    },
    color() {
      return this.$store.state.theme.fabsColor;
    },
    dark() {
      return this.$store.state.theme.fabsDark;
    },
    elevation() {
      return this.$store.state.theme.fabsElevation;
    },
    enableUp() {
      return this.$store.state.theme.fabUp;
    },
    readonly() {
      return this.$store.state.data.settings.readonly;
    },
  },
};
</script>
